export const roleHierarchyManagementKeyFactory = {
  all: ['roleHierarchyManagement'] as const,
  currentUser: () =>
    [...roleHierarchyManagementKeyFactory.all, 'currentUser'] as const,
}
